export const OPERATION_FLAGS_BITS: { bit: number; label: string }[] = [
  { bit: 0, label: 'Error Log Enable' },
  { bit: 1, label: 'Debug Report Enable' },
  { bit: 2, label: 'Stationary Detection' },
  { bit: 3, label: 'Data Encryption' },
  { bit: 4, label: 'Silence Mode' },
  { bit: 5, label: 'LEDs' },
  { bit: 6, label: 'Put on Detection for sensor measuring' },
  {
    bit: 7,
    label:
      'Trigger body temperature alert even when the heart rate reading is invalid',
  },
  { bit: 8, label: 'Auto wake-up by motion' },
  { bit: 9, label: 'Panic Button' },
  { bit: 10, label: 'Check Stationary only when Put-Off' },
  { bit: 11, label: 'Keep TCP Connection Alive' },
  { bit: 12, label: 'Trigger free-fall alert even when put-off' },
  { bit: 13, label: 'Log Debug data to SD Card' },
  { bit: 14, label: 'Show Network Status by LED' },
  { bit: 15, label: 'Disable Key Shutdown' },
];

export const OPERATION_FLAGS2_BITS: { bit: number; label: string }[] = [
  { bit: 0, label: 'Beacon Format 2 Enable' },
  { bit: 1, label: 'Short Report Enable' },
  { bit: 2, label: 'Short Report with HR and Body Temp.' },
  { bit: 3, label: 'Short Report with Positioning' },
  { bit: 4, label: 'PA with LED and Vibration Enable' },
  { bit: 5, label: 'Panic Button with Press Type' },
  { bit: 6, label: 'PA with Introduction' },
  { bit: 7, label: 'Use DasVPro' },
  { bit: 8, label: 'Workaround of Epson HR Sensor' },
];
